import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  clear (): void {
    const flashMessages = document.querySelectorAll('.flash-alert')
    flashMessages.forEach((message) => {
      message.remove()
    })
  }
}
